const actions = {
  SET_STATE: 'loan/SET_STATE',
  SET_TAB_KEY: 'loan/SET_TAB_KEY',
  GET_ZERO_LOAN_SUMMARY: 'loan/GET_ZERO_LOAN_SUMMARY',
  GET_ALL_LOAN_REQUEST: 'loan/GET_ALL_LOAN_REQUEST',
  GET_3_MONTH_LOAN: 'loan/GET_3_MONTH_LOAN',
  GET_ZERO_LOAN_REQUEST: 'loan/GET_ZERO_LOAN_REQUEST',
  GET_LOAN_REPAY_DETAIL: 'loan/GET_LOAN_REPAY_DETAIL',
  GET_ZERO_LOAN_DETAIL: 'loan/GET_ZERO_LOAN_DETAIL',
  GET_ZERO_LOAN_TRANSACTION: 'loan/GET_ZERO_LOAN_TRANSACTION',
  APPROVE_DECLINE_LOAN: 'loan/APPROVE_DECLINE_LOAN',
  GET_ALL_PROC_TRANS: 'loan/GET_ALL_PROC_TRANS',
  GET_ALL_LOAN_TRANS: 'loan/GET_ALL_LOAN_TRANS',
  PROCESS_LOAN: 'loan/PROCESS_LOAN',
  REFUND_LOAN: 'loan/REFUND_LOAN',
  CLOSE_LOAN: 'loan/CLOSE_LOAN',
  ARCHIVED_LOAN: 'loan/ARCHIVED_LOAN',
}

export default actions
